module.exports = __webpack_public_path__ + "img/1.8aa0deb0.png";